import FormType from "../../../Components/Form/FormType";
import { ROLES } from "./Roles";

const AnnouncementViewFormOptions = {
  Fields: [
    {
      element: FormType.Input,
      required: true,
      name: "title",
      label: "Title",
      value: null,
      disabled: true,
      placeholder: "Insert announcement here",
    },
    {
      element: FormType.TextArea,
      required: true,
      name: "message",
      label: "Content",
      value: null,
      disabled: true,
      placeholder: "What is the content of this announcement",
    },
    [
      {
        element: FormType.DateOnly,
        name: "startDate",
        label: "Start Date",
        value: null,
        required: true,
        disabled: true,
        flex: 48,
      },
      {
        element: FormType.DateOnly,
        name: "endDate",
        label: "End Date",
        value: null,
        required: true,
        disabled: true,
        flex: 48,
      },
    ],
    {
      element: FormType.MultiSelectDropDown,
      name: "userConfiguration",
      label: "User Configuration",
      options: ROLES,
      value: [],
      disabled: true,
    },
  ],
  Buttons: [
    {
      type: "button",
      text: "Delete",
      className: "btn btn-delete",
      onClick: () => {}
    },
    {
      type: "button",
      text: "Edit",
      className: "btn btn-save",
      onClick: () => {}
    },
  ],
};

export default AnnouncementViewFormOptions;